/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Servis_TitleInputs */

const tr_servis_title = /** @type {(inputs: Servis_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Servis Sözleşmesi (SaaS Eki)`)
};

const en_servis_title = /** @type {(inputs: Servis_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Service Agreement (SaaS Annex)`)
};

const de_servis_title = /** @type {(inputs: Servis_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Servicevertrag (SaaS-Anhang)`)
};

const ru_servis_title = /** @type {(inputs: Servis_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сервисный договор (приложение SaaS)`)
};

/**
* | output |
* | --- |
* | "Service Agreement (SaaS Annex)" |
*
* @param {Servis_TitleInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const servis_title = /** @type {((inputs?: Servis_TitleInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Servis_TitleInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_servis_title(inputs)
	if (locale === "de") return de_servis_title(inputs)
	if (locale === "ru") return ru_servis_title(inputs)
	return tr_servis_title(inputs)
});